import type { ISerializableDrawingShape } from '~/core/models';
import { ProductCatalogMap, SelectedItemMap } from '~/core/models';
import { ColorModel } from '~/core/models/color.model';
import { CustomerInfo } from '~/core/models/customer-info.model';
import { PricedProduct } from '~/core/models/priced-product.model';
import { ProductDetails } from '~/core/models/product-details.model';
import { SaveEstimateItem } from '~/core/models/save-estimate-dto';

export interface ProductNote {
  productDescription: string;
  note: string;
}

export interface Estimate {
  customerInfo?: Partial<CustomerInfo>;
  estimateNumber?: string;
  zipCode?: string;
  storeId?: number;
  color?: ColorModel;
  applySameEdge: boolean;
  qteGrpID: number | null;
  materialId: string | null;
  materialDesc: string | null;
  faucets: SelectedItemMap;
  cutOuts: SelectedItemMap;
  tearOuts: SelectedItemMap;
  chipMinimizers: SelectedItemMap;
  optionalProducts: SelectedItemMap;
  productCatalog: ProductCatalogMap;
  quoteList?: number[];
  productList?: Partial<ProductDetails>[];
  drawingShapes?: ISerializableDrawingShape[];
  lineItems: SaveEstimateItem[];
  productNotes: ProductNote[];
  pricedProducts: PricedProduct[];
  plumbingItems: SelectedItemMap;
  ticketNumber?: string;
}

export const newEstimate = (
  customerInfo?: Partial<CustomerInfo>
): Estimate => ({
  estimateNumber: undefined,
  zipCode: undefined,
  storeId: undefined,
  color: undefined,
  applySameEdge: true,
  qteGrpID: null,
  materialId: null,
  materialDesc: null,
  faucets: {},
  cutOuts: {},
  tearOuts: {},
  customerInfo: { ...customerInfo },
  chipMinimizers: {},
  productCatalog: {},
  optionalProducts: {},
  lineItems: [],
  productList: [],
  productNotes: [],
  pricedProducts: [],
  drawingShapes: [],
  plumbingItems: {},
});

export const DEFAULT_ESTIMATE = newEstimate();
